import type { CSSObject } from '@emotion/react';
import { css, Global } from '@emotion/react';
import { useAppSelector } from '../grid/reduxStore/Store.ts';
import { selectTableTextDefaultStyles, selectTextDefaultStyles } from '../grid/reduxStore/textDefaultStylingSlice';
import { tiptapDefaultStyle } from '../GridDndEditor/TiptapEditor/tiptapDefaultStyle';
import { sharedTableStyles } from '../grid/reduxStore/textDefaultStylingSlice';
import { mapTableStylesToAllBlocks } from './mapTableStylesToAllBlocks.ts';

export const pricingTableTotalStyles = {
  fontWeight: 'bold',
  textAlign: 'right',
};

const TextDefaultStylesLoader = () => {
  const textDefaultStyles = useAppSelector(selectTextDefaultStyles);
  const tableTextDefaultStyles = useAppSelector(selectTableTextDefaultStyles);

  const { textBlockTableStyles, numberBlockStyles } = mapTableStylesToAllBlocks(tableTextDefaultStyles);

  const blocksWithTiptapStyle = {
    '.editor__page__draggable .tiptap': {
      ...textDefaultStyles,
      ...textBlockTableStyles,
    },
    '.editor__page__draggable .tiptap li:has(> p)': {
      color: textDefaultStyles.p.color,
    },
    '.editor__page__draggable': {
      '.py-darkGrey-row .tiptap': { ...sharedTableStyles, fontWeight: 'bold' },
      '.py-total-row .tiptap p:not([data-table-style])': pricingTableTotalStyles,
      '.py-subtotal-row .tiptap p:not([data-table-style])': pricingTableTotalStyles,
      ...numberBlockStyles,
    },
    ...tiptapDefaultStyle,
  };
  return <Global styles={css(blocksWithTiptapStyle as unknown as CSSObject)} />;
};

export default TextDefaultStylesLoader;
